import { useContext } from 'react';
import { TaskInfoContext, TaskInfoContextData } from './context';

export function useTaskInfo(): TaskInfoContextData {
    const data = useContext<TaskInfoContextData | undefined>(TaskInfoContext);

    if (!data) {
        throw new Error(
            "TaskInfoContextData unavailable. Are you sure you're using this in a nested component of an TaskInfoProvider?"
        );
    }

    return data;
}
